import { useContext, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import getCollectionDetailQuery from '../queries/collection/getCollectionDetailQuery';
import { getProductQuery } from '../queries';
import { queryRequiresZipCode } from '../queries/product/getProductQuery';
import DataProviderContext from '../react/DataProviderContext';
import { useQuery } from './useQuery';

const useCollectionDetail = ({
  collectionId, storeId, productDomains = [], zipCode, ssr = false, skip = false, lazy = false
}) => {
  // only default storeId clientside
  const context = useContext(DataProviderContext);
  const queryVariables = {
    collectionId,
    storeId: storeId || context.storeId || undefined
  };

  if (queryRequiresZipCode({ domains: productDomains }) && zipCode) {
    queryVariables.zipCode = zipCode;
  }
  const opts = {
    ssr,
    skip: skip || (!ssr && queryVariables.storeId === '8119'),
    errorPolicy: 'all',
    variables: queryVariables,
  };

  const Query = getCollectionDetailQuery({ productDomains });

  // ac3 has bug with skip, so using lazy until its fixed
  let resp;
  let ret;
  if (lazy) {
    ret = useLazyQuery(Query, opts);
    resp = ret[1] || {};
  } else {
    ret = useQuery(Query, opts);
    resp = ret;
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && resp.data && !resp.loading) {
      const { data } = resp;

      window.LIFE_CYCLE_EVENT_BUS.trigger('data-sources.data', {
        type: 'collectionDetail',
        variables: opts.variables,
        data
      });
    }
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && resp.error && !resp.loading) {
      const { data } = resp;

      window.LIFE_CYCLE_EVENT_BUS.trigger('data-sources.error', {
        type: 'collectionDetail',
        variables: opts.variables,
        data
      });
    }
  }, [resp.loading]);

  return ret;
};

export default useCollectionDetail;
